module.exports = __webpack_public_path__ + "img/lens-174-plus-07.b39fb6e5.png";